import { AppLoading } from "components/App/components/AppLoading";
import { compiledClientConfig } from "config";
import { useCompanyContext } from "context/companyContext";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { type LDContext, LDProvider, useLDClient } from "launchdarkly-react-client-sdk";

const FlagsReady: FC = ({ children }) => {
  const ldClient = useLDClient();
  return ldClient ? <>{children}</> : <AppLoading />;
};

export const LaunchDarklyProvider: FC = ({ children }) => {
  const { user } = useAuthenticatedUser();
  const {
    state: { company },
  } = useCompanyContext();

  if (!user || !company) return <>{children}</>;

  const context: LDContext = {
    kind: "multi",
    organization: { key: company.id, name: company.name },
    user: {
      email: user.email,
      firstName: user.givenName,
      key: user.id,
      lastName: user.familyName,
    },
  };

  return (
    <LDProvider
      clientSideID={compiledClientConfig.launchDarkly?.clientSideId ?? ""}
      context={context}
      deferInitialization
      key={`${user.id}:${company.id}`}
      options={{ bootstrap: "localStorage" }}
      timeout={5}
    >
      <FlagsReady>{children}</FlagsReady>
    </LDProvider>
  );
};
